"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAdsParser = void 0;
const constants_1 = require("../utils/constants");
const AbstractAdsParser_1 = require("./AbstractAdsParser");
class InternalAdsParser extends AbstractAdsParser_1.AbstractAdsParser {
    init() {
        var _a;
        if (!((_a = this.clips) === null || _a === void 0 ? void 0 : _a.length)) {
            console.warn("[InternalAdsStitcher] No ad clip data available.");
            return;
        }
        let time = 0;
        let adDuration = 0;
        const adBlocks = [];
        this.clips.forEach(({ category, duration = 0, title = "" }, index) => {
            var _a;
            if (category === "ad") {
                // Merge consequent clips of ads into one ad block
                // Only create block for the first in the sequence only, then push all the clips to it
                if (((_a = this.clips[index - 1]) === null || _a === void 0 ? void 0 : _a.category) !== "ad") {
                    adBlocks.push({
                        startTime: time,
                        endTime: time,
                        duration: 0,
                        relativeStartTime: time - adDuration,
                        ads: [],
                    });
                }
                // Get current (last) block. It will always exist, but need condition because typescript doesn't know
                const adBlock = adBlocks.at(-1);
                if (adBlock) {
                    adBlock.endTime += duration;
                    adBlock.duration += duration;
                    adBlock.ads.push({
                        id: `${time}_${index}`,
                        title,
                        duration,
                        system: "",
                        trackingEvents: {},
                    });
                }
                adDuration += duration;
            }
            time += duration;
        });
        adBlocks.forEach((adBlock) => {
            this.emit(constants_1.StitcherEvent.ADBLOCK, adBlock);
        });
    }
}
exports.InternalAdsParser = InternalAdsParser;
//# sourceMappingURL=InternalAdsParser.js.map